import { IconProps } from "../../../types/style";

const CommentDot = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_176_410)">
          <path
            d="M14 12.5C14 13.328 13.328 14 12.5 14C11.672 14 11 13.328 11 12.5C11 11.672 11.672 11 12.5 11C13.328 11 14 11.672 14 12.5ZM17.5 11C16.672 11 16 11.672 16 12.5C16 13.328 16.672 14 17.5 14C18.328 14 19 13.328 19 12.5C19 11.672 18.328 11 17.5 11ZM7.50001 11C6.67201 11 6.00001 11.672 6.00001 12.5C6.00001 13.328 6.67201 14 7.50001 14C8.32801 14 9.00001 13.328 9.00001 12.5C9.00001 11.672 8.32801 11 7.50001 11ZM24.5 12.84V19.5C24.5 22.257 22.257 24.5 19.5 24.5H13.583C6.58201 24.5 0.970012 19.708 0.530012 13.354C0.289012 9.87798 1.55701 6.47598 4.00901 4.02098C6.46101 1.56598 9.86301 0.293983 13.336 0.528983C19.596 0.953983 24.5 6.36098 24.5 12.84ZM22.5 12.84C22.5 7.40898 18.416 2.87798 13.201 2.52398C12.972 2.50798 12.743 2.50098 12.515 2.50098C9.85901 2.50098 7.30601 3.54898 5.42401 5.43398C3.38001 7.47998 2.32301 10.317 2.52501 13.216C2.89801 18.596 7.54901 22.501 13.584 22.501H19.501C21.155 22.501 22.501 21.155 22.501 19.501V12.841L22.5 12.84Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_176_410">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.5 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default CommentDot;
